"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Export category
var category_1 = require("./config/category");
exports.GeneralOptions = category_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/index.js
// module id = 3724
// module chunks = 2